<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} Access Contorl</div>
      <div>
        <router-link class="btn-blue" to="edit-raw-material">{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="raw-materials"
        >{{ $tc('rawmaterials', 2) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div>
      <div class="row mb-3">
        <div class="col-md-4">
          Viewing access for user: &nbsp;
          <strong>atish@binarynumbers.io</strong>
        </div>
        <div class="col-md-4">
          Role:
          <strong>Administrator</strong>
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <table class="acl-table">
        <thead>
          <tr>
            <td>
              <strong>PERMISSION</strong>
            </td>
            <td>
              <strong>LOCAL</strong>
            </td>
            <td>
              <strong>GLOBAL</strong>
            </td>
          </tr>
        </thead>
        <!-- v-for="(accessList, accessListKey) in accessControlLists" :key="accessListKey" -->
        <tbody>
          <tr>
            <td colspan="3">
              <span class="font-italic font-weight-bold border-bottom">Access Levels</span>
            </td>
          </tr>
          <tr>
            <td>View application Information</td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
          </tr>

          <tr>
            <td>Create and edit draft apps</td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
          </tr>

          <tr>
            <td>Manage user permission</td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <td colspan="3">
              <span
                class="font-italic text-capitalize font-weight-bold border-bottom"
              >Financial Data</span>
            </td>
          </tr>
          <tr>
            <td>View Financial Data</td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
          </tr>

          <tr>
            <td>Manage order</td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <td colspan="3">
              <span
                class="font-italic text-capitalize font-weight-bold border-bottom"
              >Release Management</span>
            </td>
          </tr>
          <tr>
            <td>Manage production release</td>
            <td>
              <b-form-checkbox checked class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
          </tr>

          <tr>
            <td>Manage testing track release</td>
            <td>
              <b-form-checkbox class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
            <td>
              <b-form-checkbox v-model="checked" disabled class="j-checkbox">&nbsp;</b-form-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      checked: true
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/AccessControlList/viewAccessControl.vue